import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
import store from '../../../store';

class LivechannelTask extends AbstractRequestTask {

    constructor(url = "") {
        super();
        this.url = url;
    }

    getHeaders() {
        return {};
    }

    getUrl() {
        const https = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${https}${url}${this.url}`;
    }

    getParams() {
        const params = super.getParams();
        const epg_version = DeviceStorage.getItem('epgVersion');
        const user = store.getState().user;
        const authorization = user && user.user_token ? user.user_token : false;
        const lasttouch = user && user.lasttouch ? user.lasttouch.purchased : false;

        if (lasttouch) {
            params.lasttouch = lasttouch;
        }

        if(epg_version){
            params.epg_version = epg_version;
        }

        if(authorization){
            params.authorization = authorization;
        }

        delete params.device_name;
        delete params.user_id;
        delete params.user_token;
        delete params.HKS;
        delete params.api_version;
        delete params.device_so;
        delete params.format;
        delete params.device_id;
        delete params.node;

        return Object.assign({}, params);
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
      return ENABLE_MODAL_RETRIES;
    }
}

export default LivechannelTask;





// WEBPACK FOOTER //
// ./src/requests/tasks/cms/LivechannelTask.js